"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var Lang_js_1 = require("../Lang.js");
var LastTransactionContext_1 = __importDefault(require("./LastTransactionContext"));
var LastTransaction = function (_a) {
    var _b = _a.displayType, displayType = _b === void 0 ? 'table' : _b;
    var _c = (0, react_1.useContext)(LastTransactionContext_1.default), transaction = _c.transaction, isLoading = _c.isLoading, message = _c.message;
    return (react_1.default.createElement("div", { id: "lastTransaction" },
        isLoading && react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.CircularProgress, null),
            react_1.default.createElement(material_1.Typography, null, (0, Lang_js_1.__)("Loading most recent transaction..."))),
        !isLoading &&
            (displayType == 'info'
                ?
                    react_1.default.createElement(material_1.Typography, { variant: "body1" },
                        react_1.default.createElement(icons_material_1.Info, { color: "primary" }),
                        " ",
                        (0, Lang_js_1.__)('Note:'),
                        " ", message !== null && message !== void 0 ? message : (0, Lang_js_1.__)('No past donations through this web page on record'))
                :
                    react_1.default.createElement(material_1.TableContainer, null,
                        react_1.default.createElement(material_1.Table, { sx: { maxWidth: 480 }, "aria-label": "{ __('Transaction details') }" },
                            react_1.default.createElement(material_1.TableBody, null,
                                react_1.default.createElement(material_1.TableRow, null,
                                    react_1.default.createElement(material_1.TableCell, { component: "th", scope: "row" }, (0, Lang_js_1.__)('Date')),
                                    react_1.default.createElement(material_1.TableCell, null, new Date(transaction.created).toLocaleDateString(Lang_js_1.lang))),
                                react_1.default.createElement(material_1.TableRow, null,
                                    react_1.default.createElement(material_1.TableCell, { component: "th", scope: "row" }, (0, Lang_js_1.__)('Login')),
                                    react_1.default.createElement(material_1.TableCell, null, transaction.login)),
                                react_1.default.createElement(material_1.TableRow, null,
                                    react_1.default.createElement(material_1.TableCell, { component: "th", scope: "row" }, (0, Lang_js_1.__)('Amount')),
                                    react_1.default.createElement(material_1.TableCell, null, '$' + (transaction.amount).toLocaleString('us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))),
                                react_1.default.createElement(material_1.TableRow, null,
                                    react_1.default.createElement(material_1.TableCell, { component: "th", scope: "row" }, (0, Lang_js_1.__)('Description')),
                                    react_1.default.createElement(material_1.TableCell, null, transaction.description))))))));
};
exports.default = LastTransaction;
